<!-- <div *ngIf="taskLoaded() && isInfoLoaded()"> -->
<div class="wrapper wrapper-content">
  <div class="container-fluid" *ngIf="isInfoLoaded()">
    <!-- 1. ZONA MENSAJE
  <blockquote class="lead">
    <i class="fa fa-2x fa-info-circle" aria-hidden="true"></i> Esta es la ficha
    de publicación
  </blockquote>
  -->
    <div class="row m-t-md">
      <div class="col-12">
        <formPlyca [formConfig]="formConfig" #frmPUB></formPlyca>
      </div>
    </div>

  </div>
</div>